import React, { useState } from "react"
import { colors, fonts, glyphs } from "../../Styles"
import { ReportShortCut_Type } from "../../Definitions"
import { AutoReport } from "../../Services/Agrisys_GqlDataCaller/WidgetCalls/GQLCalls/autoReportCall";


interface ReportShortCut_Props {
  autoReport: AutoReport;
  // header: string
  amount?: number
  onClick?: () => void
  type?: ReportShortCut_Type
}
/**
 * ReportShortCut
 * @param onClick - Function to handle onClick.
 * @param type - Type defines the icon and is either "go to report" (arrow) or "delete shortcut" (bin).
 * @returns A clickable component that shows an amount and header.
 */
export default function ReportShortCut({autoReport, onClick, type, amount}:ReportShortCut_Props) {
  const [isHovered, setIsHovered] = useState<boolean>(false)

  let _icon
  switch (type) {
    case ReportShortCut_Type.delete:
      _icon = <glyphs.Delete size="25px"/>
    break;
    case ReportShortCut_Type.goTo:
    default:
      _icon = <glyphs.Arrow size="25px"/>
    break;
  }
  
  return (
    <div onClick={onClick} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} style={{ 
      cursor: isHovered? "pointer" : "default", 
      opacity: isHovered? "0.3" : "1", 
      transition: "opacity 0.3s ease", 
      backgroundColor: colors.greyLightTertiary, 
      border: "5px solid "+colors.blueLightPrimary, 
      borderRadius: "10px", 
      width: "100%", 
      display: "grid",
      gridTemplateColumns: "45px 1fr 45px",
      gridAutoRows: "1fr",
      boxSizing: "border-box",
      gap: "10px"
    }}>  

      {amount !== undefined && (<div style={{gridArea: "1/1/2/2", display: "flex", alignItems: "center", justifyContent: "center", borderRight: "2px solid "+colors.greyLightSecondary, margin: "8px 0px" }}>
        <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary}}>{amount}</p>
      </div>)}

      <div style={{gridArea: amount !== undefined ? "1/2/2/3" : "1/1/2/3", display: "flex", alignItems: "center", padding: amount !== undefined ? "10px 0px" : "10px", justifyContent: "start", margin: "8px 0px", overflow: "hidden", position: "relative"}}>
        <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", position: "absolute", width: "100%"}}>{autoReport.name}</p>
      </div>

      <div style={{gridArea: "1/3/2/4", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.blueLightPrimary, paddingLeft: "5px"}}>
        {_icon}
      </div>
    </div>
  )
}